import React from 'react';
import { Handle, Position } from 'reactflow';
import 'src/components/selfServeWorkflows/executionView/execution-view.scss';
import { GraphLayoutDirection } from 'src/constants/selfServe/executionViewConstants';
import { SUB_WORKFLOW_TASK_TYPE } from 'src/constants/CommonConstants';

export default function TaskNode({data}) {
  const targetHandlePosition = data.alignment == GraphLayoutDirection.TopToBottom? Position.Top : Position.Left;
  const sourceHandlePosition = data.alignment == GraphLayoutDirection.TopToBottom? Position.Bottom : Position.Right;
  const expandableClass = data.isSubWorkflow
    ? ` sub-workflow-expandable${data.isExpanded ? ' sub-workflow-expanded' : ''}`
    : '';

  return (
    <>
    <Handle type="target" position={targetHandlePosition} />
    <div className={`task-node ${data.status??""}${expandableClass}`}>
      {data.taskType === SUB_WORKFLOW_TASK_TYPE && (
        <span
          className="sub-workflow-marker"
          data-testid="sub-workflow-node-badge"
        >
          <span className="sub-workflow-marker__icon" aria-hidden="true">🧩</span>
          Sub-workflow
        </span>
      )}
      {data.taskName}
    </div>
    <Handle type="source" position={sourceHandlePosition} />
    </>
  );
}

